import React, { useState, FormEvent, ChangeEvent } from 'react'
import axios from 'axios'
import { API_URL, config } from '../components/Include';
import { Alerts } from '../components/notify';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [applicant, setApplicant] = useState({
    info_type: '',
    info: ''
  });

  const [errors, setErrors] = useState({
    errorMessage: '',
    successMessage: '',
    info_type: '',
    info: '',
    is_loading: false
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let {name, value} = event.target;
    setApplicant({...applicant, [name]: value});
    setErrors({...errors, errorMessage: '', [name]: ''});
  }

  const handleChangeSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    let {name, value} = event.target;
    setApplicant({...applicant, [name]: value});
    setErrors({...errors, errorMessage: '', [name]: ''});
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    let error = {...errors}; 
    let formIsValid = true;
    let msg = 'This field is required';

    if(!applicant.info_type) {
      error.info_type = msg;
      formIsValid = false;
    } 

    if(!applicant.info) {
      error.info = msg;
      formIsValid = false;
    } 

    if(!formIsValid) {
      setErrors(error);
    }

    if(formIsValid) {
      setErrors({...errors, is_loading: true});
      const fd = new FormData();
      
      Object.entries(applicant).forEach(([key, value]) => {
        fd.append(key, value as string);
      }); 

      let url = API_URL + '/applicant/reset_password';
      
      axios.post(url, fd, config)
        .then((response: any) => {
          if(response.data.type === 'success') {
            setApplicant({...applicant, info: ''});
            setErrors({...errors, successMessage: response.data.message, is_loading: false});
          } else {
            Alerts('danger', response.data.message, 'Something went wrong!');
            setErrors({...errors, is_loading: false});
          }
        })
        .catch((error) => {
          Alerts('danger', error.message, 'Error');
          setErrors({...errors, is_loading: false});
        });
    }
  }

  return (
    <div className="row">
      {/* Sidebar with steps */}
      <div className="forgot-sidebar  col-lg-4">
        <div className="forgot-sidebar-content">
          <img src="/images/logo.png" alt="Logo" className="forgot-logo" />
          <h3 className="mb-4">Password Recovery</h3>
          <p className="mb-4">Follow these steps to reset your password and regain access to your account.</p>
          
          <div className="forgot-step">
            <div className="forgot-step-number">1</div>
            <h5>Select Information Type</h5>
            <p>Choose the type of information you have (Matriculation Number, Email, or Phone).</p>
          </div>
          
          <div className="forgot-step">
            <div className="forgot-step-number">2</div>
            <h5>Enter Your Information</h5>
            <p>Provide the information to verify your identity.</p>
          </div>
          
          <div className="forgot-step">
            <div className="forgot-step-number">3</div>
            <h5>Check Your Email</h5>
            <p>A password reset link will be sent to your registered email address.</p>
          </div>
          
          <div className="forgot-step">
            <div className="forgot-step-number">4</div>
            <h5>Create New Password</h5>
            <p>Click the link in the email to set a new password for your account.</p>
          </div>
        </div>
      </div>


      {/* Form section */}
      <div className="forgot-form-containers  col-lg-8 mt-14" style={{'marginTop': '10rem'}}>
        <div className="forgot-form-content">
          {/* Loading overlay */}
          {errors.is_loading && (
            <div className="loading-overlay">
              <div className="spinner"></div>
            </div>
          )}

          {/* Success message */}
          {errors.successMessage && (
            <div className="success-message">
              <div className="d-flex align-items-center">
                <i className="ri-checkbox-circle-line fs-4 me-2"></i>
                <p className="mb-0">{errors.successMessage}</p>
              </div>
            </div>
          )}

          <h2 className="mb-2 ">Reset Your Password</h2>
         {/*  <p className="text-muted mb-4">Enter your details below to receive a password reset link.</p>
 */}

          <p className="text-muted mb-4">The default password is <b className='text-green '>Student@1</b> if not yet changed</p>



        {/*   <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <div className="form-floating">
                <select 
                  className={`form-select text-dark ${errors.info_type ? 'is-invalid' : ''}`}
                  id="info_type"
                  name="info_type"
                  value={applicant.info_type} 
                  onChange={handleChangeSelect}
                  required
                >
                  <option value="">-- Please Select --</option>
                  <option value="matric_no">Matriculation Number</option>
                  <option value="Email">Email Address</option>
                  <option value="Telephone">Telephone Number</option>
                </select>
                <label htmlFor="info_type">What information do you have?</label>
                {errors.info_type && <div className="invalid-feedback">{errors.info_type}</div>}
              </div>
            </div>

            <div className="mb-4">
              <div className="form-floating">
                <input 
                  type="text" 
                  className={`form-control ${errors.info ? 'is-invalid' : ''}`}
                  id="info"
                  name="info"
                  placeholder="Enter your information"
                  value={applicant.info}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="info">Enter your information</label>
                {errors.info && <div className="invalid-feedback">{errors.info}</div>}
              </div>
            </div>

            <div className="d-grid gap-2 mb-4">
              <button type="submit" className="btn btn-primary forgot-btn">
                Reset Password
              </button>
            </div>

            <div className="text-center">
              <p>Remember your password? <a href="/login" className="text-primary">Back to login</a></p>
            </div>
          </form> */}

          <div className="text-center">
              <p>Remember your password? <a href="/login" className="text-primary">Back to login</a></p>
            </div>

        </div>
    
      </div>
    </div>
  )
}

export default ForgotPassword